import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faGlobe,
  faLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import CustomCarousel from "../../Components/Carousel";
import styles from "../logs/components/style.module.css";

const InputsSP = [
  { title: "Công thức", key: "CongThuc" },
  { title: "Xuất xứ", key: "XuatXu" },
  { title: "Mã số phân bón", key: "MaSoPhanBon" },
  { title: "Quy cách", key: "QuyCach" },
  { title: "Loại hàng", key: "LoaiHang" },
  { title: "Thành phần", key: "ThanhPhan" },
  { title: "Cách sử dụng", key: "CachSuDung" },
];

export default function CheckContainer() {
  const [data, setData] = useState([]);
  const param = useParams();
  const { proxy } = useSelector((state) => state);
  const [loading, setLoading] = useState(true);

  function formatDate(data, isDate) {
    const date = data ? moment.utc(data).format("DD/MM/YYYY HH:mm:ss") : "";
    if (isDate && date.toString() !== "Invalid date") {
      return { data: date, isUnsetColor: true };
    }
    return { data };
  }
  const thtruemilk = [
    "QPMC26ICV2D35CK8",
    "QPMC26ICV2H33NLM",
    "QPMC26ICV247DN8A",
    "QPMC26ICV4D3HCIK",
    "QPMC26ICV4WX2ZXK",
    "QPMC26ICV4TXOZIO",
    "QPMC26ICV4A3DNAG",
    "QPMC26ICV8XX5ZFA",
    "QPMC26ICV8B7GN5N",
    "QPMC26ICV8F3VC4Q",
    "QPMC26ICV8P7ZZPG",
    "QPMC26ICV6V77Z25",
    "QPMC26ICV6K7PNNL",
    "QPMC26ICV6E3ACUS",
    "QPMC26ICVFU79ZQ3",
    "QPMC26ICVFWX0NFZ",
    "QPMC26ICVF0XOC34",
    "QPMC26ICVFK3JC2O",
    "QPMC26ICVFM30NBR",
    "QPMC26ICVFP3LZQ6",
    "QPMC26ICVAO3NNEE",
    "QPMC26ICVAZ3FZ1G",
    "QPMC26ICVAKXVN86",
    "QPMC26ICVA27IZ6V",
    "QPMC26ICVJR71ZSY",
    "QPMC26ICVJ07LCJV",
    "QPMC26ICVJ87MCSD",
    "QPMC26ICVJEX6NIU",
    "QPMC26ICVPG3LZN4",
    "QPMC26ICVPKXRZ2N",
    "QPMC26ICVP3X7ZEY",
    "QPMC26ICVED37N5I",
    "QPMC26ICVER7UNJ1",
    "QPMC26ICVEI7ZCGJ",
    "QPMC26ICVEH3FCS6",
    "QPMC26ICVE3XOCX0",
    "QPMC26ICV3V36CJR",
    "QPMC26ICV3170NWJ",
    "QPMC26ICV3B7JCW1",
    "QPMC26ICV337EZM1",
    "QPMC26ICVSO30Z7E",
    "QPMC26ICVS676Z10",
    "QPMC26ICVSPX4CZI",
    "QPMC26ICVSCXXZWI",
    "QPMC26ICVC97HNZK",
    "QPMC26ICVC57ZZJU",
    "QPMC26ICVC271CNA",
    "QPMC26ICVC4X1ZEG",
    "QPMC26ICXUV3SNRP",
    "QPMC26ICXUW7IZEJ",
    "QPMC26ICXU43VNNX",
    "QPMC26ICXUS7SZQ1",
  ];
  const isThTruemilk =
    thtruemilk.some((code) => param.epc.startsWith(code.substring(0, 13))) ??
    false;

  useEffect(() => {
    fetch(`${proxy()}/api/Check/${param.epc}`, {
      headers: {
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        setData(res);
        setLoading(false);
      });
  }, [param.epc]);

  // useEffect(() => {
  //   if (window.location.hostname === "192.168.19.63") {
  //     const newUrl = `https://demo2-saas.mylanhosting.com${window.location.pathname}`;
  //     window.location.replace(newUrl);
  //   }
  // }, []);

  if (loading) {
    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{
          width: "100%",
          objectFit: "none",
          height: "92vh",
        }}
      >
        <img
          width={"40px"}
          className="mb-1"
          src="/images/icon/load.gif"
          alt="Loading..."
        />
      </div>
    );
  }
  const { SanPham, DonViSanXuat, EPC, message } = data || {};

  const nsxMap = {
    QPMC26ICV4TXOZIO: "27/12/2025 20:28",
    QPMC26ICV3V36CJR: "27/12/2025 20:28",
    QPMC26ICXUS7SZQ1: "10/12/2025 20:28",
    QPMC26ICV8B7GN5N: "27/12/2025 20:28",
  };

  const hsdMap = {
    QPMC26ICV4TXOZIO: "23/08/2026",
    QPMC26ICV3V36CJR: "23/08/2026",
    QPMC26ICXUS7SZQ1: "06/08/2026",
    QPMC26ICV8B7GN5N: "23/08/2026",
  };

  const isNSX = nsxMap[param.epc] || "";
  const isHSD = hsdMap[param.epc] || "";

  return (
    <>
      <div className={styles.header}>
        <div className={styles.logo}>
          <img
            src={
              isThTruemilk
                ? "/images/logo/thtruemilk.png"
                : "/images/logo/thtruemilk.png"
            }
            alt="logo"
          />
        </div>
      </div>
      <main className={styles.custom_main}>
        <div className={styles.content}>
          {message ? (
            <div className={styles.condition}>{message}</div>
          ) : (
            <>
              <div>
                {SanPham?.HinhAnh?.length > 0 ? (
                  <CustomCarousel imgs={SanPham?.HinhAnh} proxy={proxy} />
                ) : null}
                <div className={styles.title} style={{ color: EPC?.color }}>
                  {/* tem sản phẩm {EPC?.MoTaTrangThai} */}
                </div>
                {/* <div className={styles.title}>thông tin sản phẩm</div> */}
                <div
                  className={styles.title}
                  style={{
                    color: isThTruemilk && "#103a71",
                  }}
                >
                  {SanPham?.TieuDe}
                </div>
                {isThTruemilk ? (
                  <>
                    <div
                      style={{
                        whiteSpace: isThTruemilk && "break-spaces",
                      }}
                    >
                      <span style={{ fontWeight: "bold" }}>
                        Ngày Sản Xuất:{" "}
                      </span>
                      {isNSX}
                    </div>
                    <div
                      style={{
                        whiteSpace: isThTruemilk && "break-spaces",
                      }}
                    >
                      <span style={{ fontWeight: "bold" }}>Hạn Sử Dụng: </span>
                      {isHSD}
                    </div>
                  </>
                ) : null}
                {InputsSP.filter(
                  ({ key }) =>
                    !isThTruemilk ||
                    (key !== "QuyCach" &&
                      key !== "LoaiHang" &&
                      key !== "MaSoPhanBon" &&
                      key !== "CongThuc")
                ).map(({ key, title }) => (
                  <div
                    key={key}
                    style={{
                      whiteSpace: isThTruemilk && "break-spaces",
                    }}
                  >
                    <span style={{ fontWeight: "bold" }}>{title}:</span>{" "}
                    {SanPham?.[key]}
                  </div>
                ))}
              </div>
              <>
                <div id={styles.content1}>
                  {data?.LichSuTruyVet?.length > 0 &&
                    data.LichSuTruyVet.map((item, index) => (
                      <div key={index} className={styles.event}>
                        <div
                          className={styles.title}
                          style={{
                            color: isThTruemilk ? "#103a71" : item?.color,
                          }}
                        >
                          {item?.TieuDe}
                        </div>

                        {item?.fields?.map((field, index) => {
                          if (!field) {
                            return null;
                          }
                          const { data, isUnsetColor } = formatDate(
                            field?.value,
                            field?.isDate
                          );
                          return (
                            <div key={index}>
                              <div className={styles.field_title}>
                                {field?.field}:
                                <span
                                  className={`${styles.field_content} ${styles.custom_span}`}
                                  style={{
                                    color: isUnsetColor ? "unset" : "",
                                    fontWeight: field?.isDefault && "bold",
                                  }}
                                >
                                  {data}
                                </span>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ))}
                </div>
              </>
              <>
                <div
                  className={styles.title}
                  style={{
                    color: isThTruemilk && "#103a71",
                  }}
                >
                  đơn vị sản xuất
                </div>
                {isThTruemilk ? (
                  <>
                    <div className={styles.branch_name}>
                      Công ty Cổ phần Chuỗi Thực phẩm TH
                    </div>
                    <div>
                      <FontAwesomeIcon
                        icon={faLocationDot}
                        className={styles.icon}
                        style={{
                          color: isThTruemilk && "#103a71",
                        }}
                      />
                      Địa chỉ:
                      <span
                        className={styles.custom_span}
                        style={{
                          paddingLeft: "10px",
                          color: isThTruemilk && "#103a71",
                        }}
                      >
                        Số 166 đường Nguyễn Thái Học, Phường Thành Vinh, Tỉnh
                        Nghệ An, Việt Nam
                      </span>
                    </div>
                    <div>
                      <FontAwesomeIcon
                        icon={faPhone}
                        className={styles.icon}
                        style={{
                          color: isThTruemilk && "#103a71",
                        }}
                      />
                      Số điện thoại:
                      <span
                        className={styles.custom_span}
                        style={{
                          paddingLeft: "10px",
                          color: isThTruemilk && "#103a71",
                        }}
                      >
                        1800545440
                      </span>
                    </div>
                    <div>
                      <FontAwesomeIcon
                        icon={faEnvelope}
                        className={styles.icon}
                        style={{
                          color: isThTruemilk && "#103a71",
                        }}
                      />
                      Email:
                      <span
                        className={styles.custom_span}
                        style={{
                          paddingLeft: "10px",
                          color: isThTruemilk && "#103a71",
                        }}
                      >
                        chamsockhachhang@thmilk.vn
                      </span>
                    </div>
                    <div>
                      <FontAwesomeIcon
                        icon={faGlobe}
                        className={styles.icon}
                        style={{
                          color: isThTruemilk && "#103a71",
                        }}
                      />
                      Website:
                      <span
                        className={styles.custom_span}
                        style={{
                          paddingLeft: "10px",
                          color: isThTruemilk && "#103a71",
                        }}
                      >
                        <a
                          className={styles.custom_a}
                          href={DonViSanXuat?.Website}
                          target="_blank"
                          style={{
                            color: isThTruemilk && "#103a71 !important",
                          }}
                        >
                          https://www.thmilk.vn/
                        </a>
                      </span>
                    </div>
                  </>
                ) : (
                  <>
                    <div className={styles.branch_name}>
                      {DonViSanXuat?.Ten}
                    </div>
                    <div>
                      <FontAwesomeIcon
                        icon={faLocationDot}
                        className={styles.icon}
                      />
                      Địa chỉ:
                      <span
                        className={styles.custom_span}
                        style={{ paddingLeft: "10px" }}
                      >
                        {DonViSanXuat?.DiaChi}
                      </span>
                    </div>
                    <div>
                      <FontAwesomeIcon icon={faPhone} className={styles.icon} />
                      Số điện thoại:
                      <span
                        className={styles.custom_span}
                        style={{ paddingLeft: "10px" }}
                      >
                        {DonViSanXuat?.SoDienThoai}
                      </span>
                    </div>
                    <div>
                      <FontAwesomeIcon
                        icon={faEnvelope}
                        className={styles.icon}
                      />
                      Email:
                      <span
                        className={styles.custom_span}
                        style={{ paddingLeft: "10px" }}
                      >
                        {DonViSanXuat?.Email}
                      </span>
                    </div>
                    <div>
                      <FontAwesomeIcon icon={faGlobe} className={styles.icon} />
                      Website:
                      <span
                        className={styles.custom_span}
                        style={{ paddingLeft: "10px" }}
                      >
                        <a
                          className={styles.custom_a}
                          href={DonViSanXuat?.Website}
                          target="_blank"
                        >
                          {DonViSanXuat?.Website}
                        </a>
                      </span>
                    </div>
                  </>
                )}
              </>
            </>
          )}
        </div>
      </main>
    </>
  );
}
